import Loadable from 'my-components/Loadable';

export default Loadable(() => import(/* webpackChunkName: "flash-cards" */ './FlashCardDeckCtnr'), {
  hideLoader: true,
});

export const DynamicDeckForm = Loadable(() => import(/* webpackChunkName: "flash-cards" */ './DynamicDeckForm'), {
  hideLoader: true,
});
